// React
import { useEffect } from 'react';
// Redux
import { useDispatch } from 'react-redux';
// External Lib
import { useLocation, useParams } from 'react-router-dom';
import { ZIndexType } from '../../constants/ZIndexType';
// Actions
import { actions as helpCenterActions } from '../../redux/help-center-page';
// Hooks
import hooks from './hooks';
// Components
import { HelpCenterBody } from './components/help-center-body';
import Drawer from './components/drawer';
import CustomLoader from '../common/custom-loader';

import makeClasses from './styles';
import { useTheme, useMediaQuery } from '@material-ui/core';

export function HelpCenterPage() {
  const {
    categoryId: selectedCategoryId,
    articleId: selectedArticleId,
  } = useParams<any>();
  const isLoading = hooks.useIsLoading();
  const dispatch = useDispatch();
  const location = useLocation();

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const _classes = makeClasses();

  useEffect(() => {
    const articleIdParam = new URLSearchParams(location.search).get(
      'articleId',
    );
    const articleIdToSet = !!articleIdParam
      ? articleIdParam.toString()
      : selectedArticleId;
    dispatch(
      helpCenterActions.loadData(selectedCategoryId, articleIdToSet, isMdUp),
    );
  }, [dispatch, location, selectedArticleId, selectedCategoryId, isMdUp]);

  return (
    <>
      <section className={_classes.page}>
        <Drawer />
        <div className={_classes.articleContainer}>
          <CustomLoader
            invisible
            open={isLoading}
            zIndexType={ZIndexType.DRAWER}
          />
          <HelpCenterBody />
        </div>
      </section>
    </>
  );
}
